import { ReactNode } from 'react';
import style from './Sidebar.module.scss';

export interface SidebarProps {
  children?: ReactNode;
}

const NotesSidebar = ({ children }: SidebarProps) => {
  return <aside className={style.sidebar}>{children}</aside>;
};

export default NotesSidebar;
